import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { keysToSnake } from '#/api/adapters/wireCase';

/**
 * PATCH `/crm/cost-estimates/{id}`：部分更新。
 * 送 `lines` 即整份替換（同料合併）；不送則保留明細。必帶 `updatedAt`。
 */
export async function updateCostEstimate(id, body) {
  const { data: raw } = await request.patch(`/crm/cost-estimates/${id}`, keysToSnake(body));
  return parseVer4DetailResponse(raw);
}
